import { Component, OnInit, Input } from '@angular/core';

import { Area } from "../../../estruturas/areas/shared/area.model";
import { AreaApiService } from "../../../estruturas/areas/shared/area-api.service";

@Component({
    selector: 'app-tanque-movimentacao-area-form',
    template: require('./tanque-movimentacao-area-form.component.html'),
    styles: [require('./tanque-movimentacao-area-form.component.css')]
})
export class TanqueMovimentacaoAreaFormComponent implements OnInit {
    @Input() list: any[] = [];
    @Input() showMessage: boolean = false;

    areasList: Area[] = [];

    constructor(
        private _areaApiService: AreaApiService
    ) {}

    ngOnInit() {
        this.getAreas();
    }

    clickAddNew() {
        let newItem: any = {
            ativo: true,
            area: this.areasList[0]
        };

        this.list.push(newItem);
    }

    private getAreas() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Area[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.areasList = list;
                if (!this.list.length)
                    this.clickAddNew();

                this.setListBind();

            }
        }.bind(this));

        this._areaApiService.onGetAll(onDone);
    }

    private setListBind() {
        let x: number, lenX: number,
            y: number, lenY: number;

        for (x = 0, lenX = this.list.length; x < lenX; x++) {
            for (y = 0, lenY = this.areasList.length; y < lenY; y++) {
                if (this.list[x].areaId === this.areasList[y].id) {
                   this.list[x].area = this.areasList[y];
                   break;
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanque-movimentacao-area-form/tanque-movimentacao-area-form.component.ts
 **/